import { Box } from "@mui/material";
import { Icon } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { Props } from "./customModal.types";
import {
  CloseDialog,
  CloseIcon,
  DialogContainer,
  DialogContentWrapper,
  DialogHeaderContainer,
  DialogHeaderTextContainer,
  StyledDialogTitle,
  DialogContainerSmall,
  ButtonRow,
  Column,
  ColumnHeader,
  Row,
  Button,
  Paragraph,
  DropDownText,
  DialogContainerMedium,
  SwitchDropdownDiv,
} from "./customModal.styles";

const Wrapper = ({
  onClose,
  children,
  titleText,
  titleComponent,
  open,
  isScrollable,
  size = "large",
  sensitiveData,
  hasMaxWidth = true,
  ...rest
}: React.PropsWithChildren<Props>) => {
  if (size === "large") {
    return (
      <DialogContainer
        open={open}
        onClose={onClose}
        aria-labelledby="dialog-title"
        size={size}
        {...rest}
      >
        {(titleText || titleComponent) && (
          <StyledDialogTitle id="dialog-title">
            <DialogHeaderContainer
              size={size}
              data-testid="DialogHeaderContainer"
            >
              {titleText && (
                <DialogHeaderTextContainer>
                  <Typography
                    insensitive={!sensitiveData}
                    variant="h3"
                    data-testid="slot-dialog-title-text"
                  >
                    {titleText}
                  </Typography>
                </DialogHeaderTextContainer>
              )}

              {titleComponent}

              <CloseDialog>
                <CloseIcon onClick={onClose}>
                  <Icon.Close data-testid="customModalCloseIcon" />
                </CloseIcon>
              </CloseDialog>
            </DialogHeaderContainer>
          </StyledDialogTitle>
        )}

        <DialogContentWrapper
          isScrollable={isScrollable}
          $hasTitle={Boolean(titleText || titleComponent)}
        >
          {children}
        </DialogContentWrapper>
      </DialogContainer>
    );
  }
  if (size === "medium") {
    return (
      <DialogContainerMedium
        open={open}
        onClose={onClose}
        aria-labelledby="dialog-title"
      >
        <StyledDialogTitle id="dialog-title">
          <DialogHeaderContainer
            size={size}
            data-testid="DialogHeaderContainer"
          >
            <DialogHeaderTextContainer>
              <Typography variant="h3" data-testid="slot-dialog-title-text">
                {titleText}
              </Typography>
            </DialogHeaderTextContainer>
            <CloseDialog>
              <CloseIcon onClick={onClose}>
                <Icon.Close data-testid="customModalCloseIcon" />
              </CloseIcon>
            </CloseDialog>
          </DialogHeaderContainer>
        </StyledDialogTitle>
        <DialogContentWrapper isScrollable={isScrollable}>
          {children}
        </DialogContentWrapper>
      </DialogContainerMedium>
    );
  }
  return (
    <DialogContainerSmall
      open={open}
      onClose={onClose}
      aria-labelledby="dialog-title"
    >
      <Box sx={{ padding: "40px", maxWidth: hasMaxWidth ? "412px" : "none" }}>
        <Typography
          variant="h3"
          data-testid="slot-dialog-title-text"
          sx={{ textAlign: "center" }}
        >
          {titleText}
        </Typography>
        <Box sx={{ marginTop: "10px" }}>{children}</Box>
      </Box>
    </DialogContainerSmall>
  );
};

export default {
  Wrapper,
  Row,
  Column,
  ColumnHeader,
  ButtonRow,
  Button,
  Paragraph,
  DropDownText,
  SwitchDropdownDiv,
};
